import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { EMPTY, iif, of } from 'rxjs';
import { map, mergeMap, withLatestFrom, catchError } from 'rxjs/operators';

/* notification service */
import { NotificationService } from 'src/app/features/shared/services/notification-service/notification.service';

/* jsonata object class */
import { JSONAtaObject } from 'src/app/features/shared/helper-classes';

/* lodash lib */
import * as lodash from 'lodash';

/* DataStorage interface for ngrx */
import { DataStorage } from 'src/app/features/data-stores/data-storage.interface';

/* navigate action */
import { Navigate } from 'src/app/features/data-stores/router-data-store/state/router-data-store.actions';

/* Workflow Management API Service */
import { WorkflowManagementControllerService } from 'src/app/features/shared/sdk/services/workflow-management-controller.service';

/* tour-data-store actions */
import * as TourDataStoreActions from 'src/app/features/data-stores/tour-data-store/state/tour-data-store.actions';

/* api services */
import { TourControllerService, WhatsappControllerService } from 'src/app/features/shared/sdk/services';

export const navigatePathAfterCreatingInstance = '/tours/';
export const navigatePathAfterUpdatingInstance = '/tours/';
@Injectable()
export class TourDataStoreEffects {
  constructor(
    private actions$: Actions,
    private store: Store<DataStorage>,
    private notificationService: NotificationService,
    private workflowManagementApi: WorkflowManagementControllerService,
    private tourApiService: TourControllerService,
    private whatsappControllerService: WhatsappControllerService,
  ) {
    // prettier-ignore
    // #region customCode: data-store-effects__constructor__start

    // #endregion customCode: data-store-effects__constructor__start

    // prettier-ignore
    // #region customCode: data-store-effects__constructor__end

    // #endregion customCode: data-store-effects__constructor__end
  }

  GetActiveTourId$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TourDataStoreActions.InitFetchingActiveTourWithRelations),
      withLatestFrom(
        this.store.select((state) => state.RouterDataStore.params),
      ),
      /* dataset */
      mergeMap(([action, params]) => {
        const data = {
          eventPayload: action['payload'] ?? {},
          params,
        };
        const initialPayload = of(JSONAtaObject.chain(data));
        return initialPayload;
      }),

      // prettier-ignore
      // #region customCode: data-store-effects__pre-data-transformation__start

      // #endregion customCode: data-store-effects__pre-data-transformation__start

      /* pre data transformation */
      mergeMap(payloadAsJsonataObj => {
        /* Pre Data Transformation Step 1 ( Map ) */
        /* get value of the passed jsonata object */
        const data = <any>payloadAsJsonataObj.value;
        /* transform data */
        const transformedData = JSONAtaObject.chain(data).transform(`
              { "id": params.id }
            `);
        return transformedData;
      }),
      // prettier-ignore
      // #region customCode: data-store-effects__pre-data-transformation__end

      // #endregion customCode: data-store-effects__pre-data-transformation__end
      /* trigger success actions */
      mergeMap((jsonataObj) => {
        /* get value of the passed jsonata object */
        const data = <any>jsonataObj.value;
        return [
          TourDataStoreActions.GetActiveTourWithRelationsById({ payload: data }),
        ];
      }),
    ),
  );

  sendTourApprovalEmailToTourClients$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TourDataStoreActions.SendTourApprovalEmailToTourClients),
      withLatestFrom(
        this.store.select((state) => state.TourDataStore.activeTour),
      ),
      /* dataset */
      mergeMap(([action, activeTour]) => {

        const data = {
          eventPayload: action['payload'] ?? {},
          activeTour,
        };

        const messageParams = {
          body: {
            to: [
              '+905532560474', // Burak	Alemdar
              '+905442560475', // Efe	Alemdar
              '+905336684311', // Meric	Bicakcioglu
              '+905456831911', // Can Mustu
              '+13472559099', // Tansel Oz
              '+905345825261', // Can Erden
            ],
            template: 'participant_profile_update_request_1',
            locale: 'tr',
            parameters: [
              {
                key: "customer_name",
                value: action.payload.customerName || "tur katılımcısı"
              },
              {
                key: "tour_name",
                value: action.payload.tourName || "Seyahatiniz"
              }
            ]
          }
        };

        return this.whatsappControllerService.sendTemplateMessage(messageParams).pipe(
          mergeMap((response) => {
            this.notificationService.createNotification(
              'success',
              'Mesaj Gönderildi',
              'Katılımcılara bilgilendirme mesajı gönderildi.',
            );
            return [
              TourDataStoreActions.SendTourApprovalEmailToTourClientsSuccessful(),
            ];
          }),
          catchError((error) => {
            this.notificationService.createNotification(
              'error',
              'Hata',
              'Katılımcılara bilgilendirme mesajı gönderilirken bir hata oluştu.',
            );
            return [
              TourDataStoreActions.SendTourApprovalEmailToTourClientsFailure(),
            ];
          }),
        );
      }),

    ));





  /* call endpoint */
  // return this.workflowManagementApi.runEvent(params).pipe(
  //   mergeMap(response => {
  //     return of({
  //       success: true,
  //       data: response
  //     });
  //   }),
  //   catchError((error) => {
  //     return of({
  //       success: false,
  //       data: error
  //     });
  //   })
  // );

  // }),
  //     /* trigger actions */
  //     mergeMap((result) =>
  //       iif(
  //         () => result.success,
  //         /* success case */
  //         of(result.data).pipe(
  //           /* convert to jsonata object */
  //           mergeMap((data) => {
  //             return of(JSONAtaObject.chain(data));
  //           }),
  //           /* success actions */
  //           mergeMap((jsonataObj) => {
  //             /* get value of the passed jsonata object */
  //             const data = <any>jsonataObj.value;
  //             return [
  //               TourDataStoreActions.SendTourApprovalEmailToTourClientsSuccessful(),
  //             ];
  //           }),
  //         ),
  //         /* failure case */
  //         of(result.data).pipe(
  //           /* convert to jsonata object */
  //           mergeMap((data) => {
  //             return of(JSONAtaObject.chain(data));
  //           }),
  //           /* failure actions */
  //           mergeMap((jsonataObj) => {
  //             /* get value of the passed jsonata object */
  //             const data = <any>jsonataObj.value;
  //             return [
  //               TourDataStoreActions.SendTourApprovalEmailToTourClientsFailure(),
  //             ];
  //           }),
  //         ),
  //       ),
  //     ),
  //   ),
  // );

  getTours$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TourDataStoreActions.GetTours),
      mergeMap((action) => {
        return this.tourApiService.find().pipe(
          mergeMap((tours) => {
            const payload: any = {
              tours: tours,
            };
            return [TourDataStoreActions.GetToursSuccessful({ payload })];
          }),
          catchError((error) => {
            this.notificationService.createNotification(
              'error',
              'Failure',
              'There was an error while fetching data.',
            );
            return [TourDataStoreActions.GetToursFailure()];
          }),
        );
      }),
    ),
  );

  getTourById$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TourDataStoreActions.GetTourById),
      mergeMap((action) => {
        return this.tourApiService
          .findById({
            id: action.payload.id,
          })
          .pipe(
            mergeMap((tour) => {
              const payload: any = {
                tour: tour,
              };
              return [TourDataStoreActions.GetTourByIdSuccessful({ payload })];
            }),
            catchError((error) => {
              this.notificationService.createNotification(
                'error',
                'Failure',
                'There was an error while fetching data.',
              );
              return [TourDataStoreActions.GetTourByIdFailure()];
            }),
          );
      }),
    ),
  );

  getActiveTourWithRelationsById$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TourDataStoreActions.GetActiveTourWithRelationsById),
      /* dataset */
      mergeMap((action) => {
        const data = action['payload'] ?? {};
        const initialPayload = of(JSONAtaObject.chain(data));
        return initialPayload;
      }),

      // prettier-ignore
      // #region customCode: data-store-effects__pre-data-transformation__start

      // #endregion customCode: data-store-effects__pre-data-transformation__start

      /* pre data transformation */
      mergeMap(payloadAsJsonataObj => {
        /* Pre Data Transformation Step 1 ( Map ) */
        /* get value of the passed jsonata object */
        const data = <any>payloadAsJsonataObj.value;
        /* transform data */
        const transformedData = JSONAtaObject.chain(data).transform(`
              {
            "id": id,
            "filter": {
              "include": [
                "participants",
              ]
            }
          }
          
            `);
        return transformedData;
      }),
      // prettier-ignore
      // #region customCode: data-store-effects__pre-data-transformation__end

      // #endregion customCode: data-store-effects__pre-data-transformation__end
      /* process */
      mergeMap(payloadAsJsonataObj => {
        /* get value of the passed jsonata object */
        const data = <any>payloadAsJsonataObj.value;

        return this.tourApiService.findById(data).pipe(
          mergeMap(response => {
            return of({
              success: true,
              data: response
            });
          }),
          catchError((error) => {
            return of({
              success: false,
              data: error
            });
          })
        );

      }),
      /* trigger actions */
      mergeMap((result) =>
        iif(
          () => result.success,
          /* success case */
          of(result.data).pipe(
            /* convert to jsonata object */
            mergeMap((data) => {
              return of(JSONAtaObject.chain(data));
            }),
            // prettier-ignore
            // #region customCode: data-store-effects__post-data-transformation__start

            // #endregion customCode: data-store-effects__post-data-transformation__start

            /* post data transformation */
            mergeMap(payloadAsJsonataObj => {
              /* Post Data Transformation Step 1 ( Map ) */
              /* get value of the passed jsonata object */
              const data = <any>payloadAsJsonataObj.value;
              /* transform data */
              const transformedData = JSONAtaObject.chain(data).transform(`
                    {
              "activeTour": $
          }
                  `);
              return transformedData;
            }),
            // prettier-ignore
            // #region customCode: data-store-effects__post-data-transformation__end

            // #endregion customCode: data-store-effects__post-data-transformation__end
            /* success actions */
            mergeMap((jsonataObj) => {
              /* get value of the passed jsonata object */
              const data = <any>jsonataObj.value;
              return [
                TourDataStoreActions.GetActiveTourByIdWithRelationsSuccessful({ payload: data }),
              ];
            }),
          ),
          /* failure case */
          [],
        ),
      ),
    ),
  );

  createTour$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TourDataStoreActions.CreateTour),
      mergeMap((action) => {
        const params = {
          body: action.payload.tour,
        };
        return this.tourApiService.create(<any>params).pipe(
          mergeMap((tour) => {
            this.notificationService.createNotification(
              'success',
              'Successful',
              'Your data has been saved successfully.',
            );
            const payload: any = {
              tour: tour,
            };
            return [
              TourDataStoreActions.CreateTourSuccessful({ payload }),
              Navigate({
                payload: { path: navigatePathAfterCreatingInstance },
              }),
            ];
          }),
          catchError((error) => {
            this.notificationService.createNotification(
              'error',
              'Failure',
              'There was an error while saving the data.',
            );
            return [TourDataStoreActions.CreateTourFailure()];
          }),
        );
      }),
    ),
  );

  updateTour$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TourDataStoreActions.UpdateTour),
      mergeMap((action) => {
        const params = {
          id: action.payload.id,
          body: action.payload.data,
        };
        return this.tourApiService.updateById(<any>params).pipe(
          mergeMap(() => {
            this.notificationService.createNotification(
              'success',
              'Veri güncellendi',
              'Verileriniz başarıyla güncellendi.',
            );
            return [
              TourDataStoreActions.GetTours(),
              Navigate({
                payload: { path: navigatePathAfterUpdatingInstance },
              }),
            ];
          }),
          catchError((error) => {
            this.notificationService.createNotification(
              'error',
              'Failure',
              'There was an error while updating the data.',
            );
            return [TourDataStoreActions.UpdateTourFailure()];
          }),
        );
      }),
    ),
  );

  deleteTour$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TourDataStoreActions.DeleteTour),
      mergeMap((action) => {
        const params = { id: action.payload.id };
        return this.tourApiService.deleteById(params).pipe(
          mergeMap(() => {
            this.notificationService.createNotification(
              'success',
              'Success',
              'Your data has been deleted successfully.',
            );
            const payload: any = {
              id: action.payload.id,
            };
            return [TourDataStoreActions.DeleteTourSuccessful({ payload })];
          }),
          catchError((error) => {
            this.notificationService.createNotification(
              'error',
              'Failure',
              'There was an error while deleting the data.',
            );
            return [TourDataStoreActions.DeleteTourFailure()];
          }),
        );
      }),
    ),
  );
}
